import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { MatchAdmin, MatchStatus, ResultVerification } from '../../../models/interfaces/Match';
import OfficialVerificationAndFinishMatch from './OfficialVerificationAndFinishMatch';

interface Props {
    matchAdmin: MatchAdmin;
    onHideModal: () => void;
    confirmFinishMatch: boolean;
    cancelPromptFinishMatchConfirmation: () => void;
    promptFinishMatchConfirmation: () => void;
    resetConfirmFinishMatch: () => void;
}

const FinishMatchFooter = ({
    matchAdmin,
    onHideModal,
    confirmFinishMatch,
    cancelPromptFinishMatchConfirmation,
    promptFinishMatchConfirmation,
    resetConfirmFinishMatch,
}: Props) => {
    const [completeMatchError, setCompleteMatchError] = useState<string | undefined>();

    let matchCompleted = matchAdmin.match.status === MatchStatus.completed;

    const handleCompleteMatch = (
        updateStatCallBack: () => void,
        verification?: ResultVerification
    ) => {
        if (matchCompleted) {
            matchAdmin
                .updateResultVerification(verification)
                .then(() => {
                    onHideModal();
                })
                .catch((error) => {
                    console.error(error);
                    setCompleteMatchError(error);
                })
                .finally(() => {
                    resetConfirmFinishMatch();
                    updateStatCallBack();
                });
        } else {
            matchAdmin
                .finishMatch(verification)
                .then(() => {
                    onHideModal();
                })
                .catch((error) => {
                    console.error(error);
                    setCompleteMatchError(error);
                })
                .finally(() => {
                    resetConfirmFinishMatch();
                    updateStatCallBack();
                });
        }
    };

    if (confirmFinishMatch) {
        return (
            <OfficialVerificationAndFinishMatch
                handleBack={cancelPromptFinishMatchConfirmation}
                onSubmit={handleCompleteMatch}
                submissionError={completeMatchError}
                matchCompleted={matchCompleted}
                modalSize="large"
            />
        );
    }

    return (
        <Row className="justify-content-center">
            <Col xs="auto">
                <Button
                    onClick={promptFinishMatchConfirmation}
                    variant="success"
                    className="shadow-sm"
                >
                    {matchCompleted ? 'Add Official Verification' : 'Finish Match'}
                </Button>
            </Col>
        </Row>
    );
};

export default FinishMatchFooter;
